import type { participation as en } from '@/i18n/locales/en/participation';
import type { Translation } from '@/i18n/types';

export const participation: Translation<typeof en> = {
  page: {
    title: 'Partecipazione',
    lead: "L'imbuto di coinvolgimento: da invitato a strutturalmente attivo, più i tassi di coinvolgimento giornalieri.",
    noScope: "Seleziona un'azienda per vedere i suoi numeri di partecipazione.",
    noDepartments: 'Nessun reparto qui ha statistiche che puoi vedere.',
    disclaimer:
      'Tutti i valori sono indicazioni di benessere e non costituiscono una diagnosi medica. Le tendenze vengono mostrate solo con un numero sufficiente di partecipanti (privacy by design).',
  },
  filters: {
    department: {
      label: 'Reparto',
    },
    location: {
      label: 'Sede',
      all: 'Tutte le sedi',
    },
  },
  funnel: {
    title: 'Imbuto di coinvolgimento',
    pctOfPrevious: '{{pct}}% del passo precedente',
    steps: {
      invited: 'Invitati',
      activated: 'Attivati',
      active_7d: 'Attivi (7g)',
      active_30d: 'Attivi (30g)',
      structurally_active: 'Strutturalmente attivi',
      needs_reactivation: 'Da riattivare',
    },
  },
  rates: {
    title: 'Tassi di coinvolgimento',
    keys: {
      daily_sync_pct: 'Sincronizzazione giornaliera',
      ai_coach_use_pct: 'Uso del coach IA',
      challenge_participation_pct: 'Partecipazione alle challenge',
      notification_open_pct: 'Apertura notifiche',
      break_adoption_pct: 'Adozione delle pause',
      focus_rhythm_pct: 'Ritmo di concentrazione',
    },
  },
  breakdown: {
    department: 'Per reparto',
    location: 'Per sede',
    pilotGroup: 'Per gruppo pilota',
    empty: 'Ancora nessun dato da suddividere.',
    pilotGroupEmpty: 'Nessun pilot copre ancora questo reparto.',
    ratio: '{{activated}}/{{invited}} · {{pct}}%',
    shielded: {
      badge: 'Protetto',
      message:
        'Partecipanti insufficienti ({{invited}}) per una visualizzazione sicura per la privacy — richiesti almeno {{min}}.',
    },
    columns: {
      name: 'Nome',
      invited: 'Invitati',
      activated: 'Attivati',
      active30d: 'Attivi (30g)',
    },
  },
  status: {
    noData: '—',
  },
};
